import React, { useState, useCallback } from "react";
import { Icon } from "antd";
import axios from "axios";
import { getBrandsAndProducts } from "./phototheque.utils";

const Item = ({ id, label, client_product_id, brandLabel, selected, onSelect }) => {
  return (
    <div
      onClick={() => onSelect(id)}
      style={{
        borderRadius: 20,
        backgroundColor: "white",
        padding: 10,
        marginBottom: 10,
        paddingLeft: 15,
        border: selected ? "solid 1px #FF5200" : "solid 1px #ccc",
        cursor: "pointer"
      }}
    >
      <span class="p-phototheque-brands" style={{ color: selected ? "#FF5200" : "#515151" }}>
        {selected ? <Icon type="check" style={{ marginRight: 10 }} /> : null}
        {label}
      </span>
      {brandLabel && <span style={{ fontSize: 10 }}>{brandLabel}</span>}
      {client_product_id && <span style={{ fontSize: 10 }}>{client_product_id}</span>}
    </div>
  );
};

const SelectModalContent = ({
  updateBrandsAndProducts,
  categories,
  selectedBrands = [],
  selectedProducts = [],
  media
}) => {
  const preselected = selectedBrands
    .map(brand => [`brand-${brand.id}`, true])
    .concat(selectedProducts.map(product => [product.id, true]));
  const brandsList = [];
  const productsList = [];
  const [selected, setSelected] = useState(new Map(preselected));
  const onSelect = useCallback(
    id => {
      const newSelected = new Map(selected);
      newSelected.set(id, !selected.get(id));
      const { brands, products } = getBrandsAndProducts(categories, newSelected);
      updateBrandsAndProducts(media._id, brands, products);

      setSelected(newSelected);
    },
    [selected]
  );
  const keysArrayOfSelected = [...selected.keys()].filter(key => selected.get(key));

  categories.forEach(category =>
    category.families.forEach(family =>
      family.brands.forEach(brand => {
        if (brandsList.findIndex(brandPushed => `brand-${brand.brandId}` === brandPushed.id) === -1) {
          brandsList.push({ label: brand.label, id: `brand-${brand.brandId}` });
        }
        if (keysArrayOfSelected.findIndex(key => key === `brand-${brand.brandId}`) > -1) {
          brand.products.forEach(product => {
            productsList.push({
              id: `product-${product.ean}`,
              label: product.label,
              client_product_id: product.client_product_id,
              ean: product.ean,
              brandId: brand.brandId,
              brandLabel: brand.label,
              familyId: family.familyId,
              familyLabel: family.label,
              categoryId: category.categoryId,
              categoryLabel: category.label
            });
          });
        }
      })
    )
  );

  return (
    <React.Fragment>
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-around" }}>
        <div style={{ display: "flex", flexDirection: "column", width: "40%" }}>
          {brandsList.map(brand => (
            <Item
              key={brand.id}
              id={brand.id}
              label={brand.label}
              selected={!!selected.get(brand.id)}
              onSelect={onSelect}
            ></Item>
          ))}
        </div>
        <div style={{ display: "flex", flexDirection: "column", width: "40%" }}>
          {productsList.map(product => (
            <Item
              key={product.id}
              id={product.id}
              label={product.label}
              selected={!!selected.get(product.id)}
              onSelect={onSelect}
            ></Item>
          ))}
        </div>
      </div>
    </React.Fragment>
  );
};
export default SelectModalContent;



// WEBPACK FOOTER //
// src/components/phototheque/SelectModalContent.js